/**
 * Bolinha vermelha de documento pendente (owner C1014323): item
 * Configurações/Perfil do menu esquerdo, avatar do topo e aba «Documentos».
 *
 * Fonte = a MESMA do aviso âmbar (`pendingRequired` sobre a lista da sessão
 * normal; nenhuma regra nova). Lida 1 vez pelo layout (provider) e de novo
 * quando a aba Documentos recarrega a lista (ex.: depois de um envio), por
 * `refresh()`. Sem provider (cadastro pendente, testes) ⇒ sem bolinha e
 * `refresh` é no-op. Erro de leitura ou tipo de pessoa indeterminável ⇒ sem
 * bolinha (fail-quiet, como o aviso da aba Geral).
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { listCompanyDocuments } from "./ContractUpload";
import { pendingRequired, resolvePersonType } from "./CompanyDocuments";
import { ARIA_PENDENCIA, PendenciaDocsContext, PendenciaDot, usePendenciaDocs } from "./pendenciaDocsContext";

export { ARIA_PENDENCIA, PendenciaDot, usePendenciaDocs };

export function PendenciaDocsProvider({ resolveDoc, children }) {
  const [pendente, setPendente] = useState(false);
  // Só a leitura mais recente escreve (molde CompanyDocuments, revisão Astra4 M3).
  const ultimo = useRef(0);
  useEffect(() => () => { ultimo.current += 1; }, []);

  const refresh = useCallback(async () => {
    const pedido = ++ultimo.current;
    try {
      const [doc, data] = await Promise.all([
        resolveDoc ? resolveDoc() : Promise.resolve(null),
        listCompanyDocuments(null),
      ]);
      if (pedido !== ultimo.current) return;
      const personType = resolvePersonType(doc, data);
      if (!personType) { setPendente(false); return; }
      const docs = (data?.documents || []).filter((d) => d.is_current !== false);
      setPendente(pendingRequired(personType, docs).length > 0);
    } catch (e) {
      if (pedido === ultimo.current) setPendente(false);
    }
  }, [resolveDoc]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PendenciaDocsContext.Provider value={{ pendente, refresh }}>
      {children}
    </PendenciaDocsContext.Provider>
  );
}
